var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.94531 23.4207C5.59531 23.4207 5.24531 23.2873 4.97844 23.0204C4.44469 22.4867 4.44469 21.621 4.97844 21.0867L21.0845 4.98118C21.6182 4.44743 22.4839 4.44743 23.0182 4.98118C23.552 5.51493 23.552 6.38064 23.0182 6.91493L6.91164 23.0204C6.64477 23.2873 6.29531 23.4207 5.94531 23.4207Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0508 23.4199C21.7008 23.4199 21.3508 23.2865 21.0839 23.0196L4.97844 6.91359C4.44469 6.37984 4.44469 5.51414 4.97844 4.97984C5.51219 4.44609 6.37789 4.44609 6.91219 4.97984L23.0182 21.0859C23.552 21.6196 23.552 22.4853 23.0182 23.0196C22.7508 23.2865 22.4008 23.4199 22.0508 23.4199Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossButton);
export default __webpack_public_path__ + "static/media/cross-button.b8c48685a16a80be6468da124683223b.svg";
export { ForwardRef as ReactComponent };